var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_56_43)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 1.75H2.828L2.8 1.54525C2.7427 1.11966 2.50892 0.72726 2.14299 0.442445C1.77706 0.15763 1.30442 0.00019938 0.814667 0L0 0V1.16667H0.814667C0.977956 1.16669 1.13556 1.21914 1.25758 1.31408C1.3796 1.40903 1.45756 1.53985 1.47667 1.68175L2.53333 9.53808C2.59063 9.96367 2.82441 10.3561 3.19034 10.6409C3.55627 10.9257 4.02891 11.0831 4.51867 11.0833H13.3333V9.91667H4.51867C4.35528 9.91663 4.19759 9.86409 4.07555 9.76903C3.95351 9.67397 3.87562 9.543 3.85667 9.401L3.76933 8.75H14.5573L16 1.75ZM13.4427 7.58333H3.61267L2.98533 2.91667H14.4047L13.4427 7.58333Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66677 14.0004C5.40314 14.0004 6.0001 13.478 6.0001 12.8337C6.0001 12.1894 5.40314 11.6671 4.66677 11.6671C3.93039 11.6671 3.33344 12.1894 3.33344 12.8337C3.33344 13.478 3.93039 14.0004 4.66677 14.0004Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 14.0004C12.0697 14.0004 12.6667 13.478 12.6667 12.8337C12.6667 12.1894 12.0697 11.6671 11.3333 11.6671C10.597 11.6671 10 12.1894 10 12.8337C10 13.478 10.597 14.0004 11.3333 14.0004Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_56_43"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 14,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.6ea1f0aeed8263354c4ff8357804a0ba.svg";
export { ForwardRef as ReactComponent };